// /* eslint-disable no-unused-expressions */
// import React, { useEffect, useState } from "react";
// import GlobalForm from "../../../components/globalForm/GlobalForm";
// import Loading from "../../../components/shared/loading/Loading";
// import { updateData } from "../../../hooks/update";
// import useFetch from "../../../hooks/useFetch";
// import { apiPath, RoutePath } from "../../../utility/Constant";

// const BusinessSubsContent = ({
//   businessSubsData,
//   handleSingleDelete,
//   apiId,
// }) => {
//   const { homeApi } = apiPath;
//   const [visibility, setVisibility] = useState(true);
//   const { title, url, website, _id } = businessSubsData ?? {};
//   const { aboutUsBusinessSubs } = RoutePath;

//   const data = [
//     {
//       elementType: "input",
//       label: "Logo Name",
//       type: "Text",
//       name: "title",
//       defaultValue: title,
//       required: false,
//     },
//     {
//       elementType: "input",
//       label: "Website Link",
//       type: "Text",
//       name: "website",
//       defaultValue: website,
//       required: false,
//     },
//     {
//       elementType: "file",
//       label: "Logo Image",
//       name: "url",
//       defaultValue: businessSubsData,
//       multiple: false,
//       fullCol: true,
//       required: true,
//     },
//   ];

//   async function helperFunction() {
//     const res = await handleSingleDelete(_id, apiId);
//     if (typeof res === "boolean" && res === true) {
//       setVisibility(false);
//     }
//   }

//   const update = async (data) => {
//     const mergedObject = Object.assign({}, data, { id: _id });
//     const res = await updateData(homeApi, mergedObject, apiId);
//     if (res?.length > 0) {
//       setTimeout(() => {
//         window.location.href = "/" + aboutUsBusinessSubs;
//       }, 600);
//     }
//   };

//   return (
//     <>
//       {visibility ? (
//         <div className="md:py-5">


//           <GlobalForm
//             data={data}
//             update={update}
//             deleteBtn={true}
//             helperFunction={helperFunction}
//             isGalleryFile={true}
//           />
//         </div>
//       ) : null}
//     </>
//   );
// };

// export default BusinessSubsContent;


/* eslint-disable no-unused-expressions */
import React, { useState } from "react";
import GlobalForm from "../../../components/globalForm/GlobalForm";
import { updateData } from "../../../hooks/update";
import { apiPath, RoutePath } from "../../../utility/Constant";
import { AnimatePresence, motion } from "framer-motion";
import { SortableHandle } from "react-sortable-hoc";
import { MdDragIndicator } from "react-icons/md";

const BusinessSubsContent = ({
  businessSubsData,
  handleSingleDelete,
  apiId,
  dragHandle
}) => {
  const { homeApi } = apiPath;
  const [visibility, setVisibility] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const { title, url, website, _id } = businessSubsData ?? {};
  const { aboutUsBusinessSubs } = RoutePath;

  const data = [
    {
      elementType: "input",
      label: "Logo Name",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: false,
    },
    {
      elementType: "input",
      label: "Website Link",
      type: "Text",
      name: "website",
      defaultValue: website,
      required: false,
    },
    {
      elementType: "file",
      label: "Logo Image",
      name: "url",
      defaultValue: businessSubsData,
      multiple: false,
      fullCol: true,
      required: true,
    },
  ];

  async function helperFunction() {
    const res = await handleSingleDelete(_id, apiId);
    if (typeof res === "boolean" && res === true) {
      setVisibility(false);
    }
  }

  const update = async (data) => {
    const mergedObject = Object.assign({}, data, { id: _id });
    const res = await updateData(homeApi, mergedObject, apiId);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + aboutUsBusinessSubs;
      }, 600);
    }
  };

  const DefaultDragHandle = SortableHandle(() => (
    <div className="pointer-events-auto cursor-move">
      <MdDragIndicator className="w-5 h-5 text-gray-400" />
    </div>
  ));

  return visibility ? (
    <div className="border rounded-lg mb-4 shadow-sm overflow-hidden">
      {/* Accordion Header */}
      <button
        className="w-full text-left px-5 py-3 bg-gray-100 hover:bg-gray-200 transition-all flex justify-between items-center"
        onClick={() => setIsOpen((prev) => !prev)}
        type="button"
      >
        <div className="flex items-center">
          <div className="mr-2">
            {dragHandle || <DefaultDragHandle />}
          </div>
          <h2 className="text-lg font-semibold uppercase">{title}</h2>
        </div>
        <span className="text-xl">{isOpen ? "−" : "+"}</span>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="p-5">
              <GlobalForm
                data={data}
                update={update}
                deleteBtn={true}
                helperFunction={helperFunction}
                isGalleryFile={true}
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  ) : null;
};

export default BusinessSubsContent;
